import script from "./custom-no-credit-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./custom-no-credit-modal.vue?vue&type=script&setup=true&lang=js"

import "./custom-no-credit-modal.vue?vue&type=style&index=0&id=38501ea6&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38501ea6"]])

export default __exports__